import React, { useEffect } from "react";
import { Box, Button, getColor, Typography } from "fds";
import "./index.scss";
import utilsCommon from "../../shared/utils/common";
import { useNavigate } from "react-router-dom";
import {
  getUserInfoFromLocalStorage,
  removeRedirectUrl,
} from "../../shared/utils/auth";
import { t } from "i18next";
import useWorkspaceStore from "../../redux/dispatcher/useWorkspaceStore";
import { ActionResponse, LoginDto } from "../../types/auth";
interface SignupProps {
  actionInfo?: ActionResponse;
}
const MailSuccess: React.FC<SignupProps> = ({ actionInfo }) => {
  const navigate = useNavigate();
  const { verifyMemberMail } = useWorkspaceStore();

  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);

  useEffect(() => {
    if (actionInfo?.makerId) verifyMemberMail(actionInfo?.makerId);
  }, []);
  return (
    <Box direction="column" alignItems="center" classes="mailVerify">
      <Box height={60} alignItems={"center"} justifyContent={"center"}>
        <img
          src={utilsCommon.renderWrapsodyECOLogo()}
          alt={"logo"}
          height={32}
          width={129}
          className="cursor pointer"
          onClick={() =>
            navigate(
              loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE"
                ? `${process.env.PUBLIC_URL}/myInbox/received`
                : `${process.env.PUBLIC_URL}/home`
            )
          }
        />
      </Box>
      <Box direction="column" classes="mailVerify-body">
        <Box classes="mailVerify-welcome" id="welcome">
          <img
            src={require("../../shared/images/pages/Signup/verify_success_left.png")}
            alt="Wrapsody eCo"
            // className="mg mr-12"
          />
          <Box direction="column" alignItems="center" justifyContent="center">
            <Typography type="h1">{t("wsLogin.welcome")}</Typography>
            <Box classes="divider" />
            <Typography>{t("wsLogin.welcomeDesc")}</Typography>
          </Box>
          <img
            src={require("../../shared/images/pages/Signup/verify_success_right.png")}
            alt="Wrapsody eCo"
          />
        </Box>
        <Button
          label={t("wsLogin.welcomeBtn")}
          width={360}
          btnStyle="fill"
          classes="mg mt-40"
          onClick={() => {
            removeRedirectUrl();
            navigate(`${process.env.PUBLIC_URL}/login`);
          }}
        />
        <Box classes="mg mt-40 mb-40">
          <img
            src={utilsCommon.renderWrapsodyECOLogo()}
            alt="Wrapsody eCo"
            width={96.8}
            height={23.1}
            className="mg mr-12"
          />
          <Typography exactColor={getColor("COLOR_TEXT_SECONDARY")}>
            {"© Fasoo"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MailSuccess;
